import React from "react";

const Spinner = () =>
  <div className="spinner-border" role="status">
    <span className="sr-only">Cargando...</span>
  </div>;

export default Spinner;